import React, { useState } from "react"
import { Divider, Input, Button, Select } from "antd"
import lockIcon from "../../images/lock.svg"

const { TextArea } = Input

export default function EditSubdimensionForm({
  dimension,
  toggleDrawer,
  updateDimensionWatcher,
  dimensionsQuestion,
}) {
  const [idDimensionParent, setIdDimensionParent] = useState(null)
  const [listDimensions, setListDimensions] = useState([])
  const [dimensionName, setDimensionName] = useState("")
  const [description, setDescription] = useState("")
  const [dimensionLock, setDimensionLock] = useState("")

  React.useEffect(() => {
    const result = dimensionsQuestion.map((row) => {
      return {
        id_dimension: row.data.id_dimension,
        name_dimension: row.data.name,
      }
    })
    setListDimensions(result)
    setIdDimensionParent(dimension.id_dimension_parent)
    setDimensionName(dimension.title)
    setDimensionLock(dimension.alias || dimension.title)
    setDescription(dimension.description)
  }, [])

  const hideFooterDrawer = () =>
    dimensionName === dimension.title &&
    description === dimension.description &&
    idDimensionParent === dimension.id_dimension_parent
  return (
    <div className="question-container">
      <div className="question-container-item">
        <span
          className="question-container-item-title"
          style={{ marginTop: "1rem" }}>
          Nombre de la subdimensión
        </span>
        <Input
          style={{ width: "60%" }}
          value={dimensionName}
          maxLength="50"
          onChange={(e) => setDimensionName(e.target.value)}
        />
      </div>
      <Divider />
      <div className="question-container-item">
        <img
          src={lockIcon}
          style={{
            position: "absolute",
            right: 32,
          }}
        />
        <span className="question-container-item-title">Dimensión</span>
        <Select
          defaultValue={idDimensionParent}
          value={idDimensionParent}
          style={{ width: "60%" }}
          className="question-container-item-dimension"
          disabled
          onChange={(value) => {
            setIdDimensionParent(value)
          }}>
          {listDimensions.map((row) => {
            return (
              <Select.Option value={row.id_dimension}>
                {row.name_dimension}
              </Select.Option>
            )
          })}
        </Select>
      </div>
      <Divider />
      <div className="question-container-item">
        <img
          src={lockIcon}
          style={{
            position: "absolute",
            right: 32,
          }}
        />
        <span className="question-container-item-title">Subdimensión</span>
        <Select
          defaultValue={dimensionLock}
          value={dimensionLock}
          style={{ width: "60%" }}
          className="question-container-item-dimension"
          disabled>
          <Select.Option value={dimensionLock}>{dimensionLock}</Select.Option>
        </Select>
      </div>
      <Divider />
      <div className="question-container-item">
        <span className="question-container-item-title">Descripción</span>
        <TextArea
          placeholder="Escribe aquí la descripción de la subdimensión..."
          rows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          maxLength={200}
        />
      </div>
      <Divider />

      {!hideFooterDrawer() && (
        <div className="footer-drawer">
          <Button
            style={{ marginRight: 8 }}
            onClick={() => {
              toggleDrawer("subdimensionDrawer", false)
              Intercom('update', { hide_default_launcher: false });
            }}
            >
            Cancelar
          </Button>
          <Button
            disabled={!dimensionName}
            type="primary"
            onClick={() => {
              const params = {
                idDimension: dimension.id_dimension_has_survey,
                params: {
                  title: dimensionName,
                  description,
                },
              }

              updateDimensionWatcher(params)
              toggleDrawer("subdimensionDrawer", false)
              Intercom('update', { hide_default_launcher: false });
            }}>
            Guardar
          </Button>
        </div>
      )}
    </div>
  )
}
